import React, { memo } from 'react';
import { Product } from '@src/core/buyerApiClient';
import { TariffsPerType } from '@src/stores/product';
import { IconCheck } from '@tabler/icons-react';
import Chip from '@src/components/reusable/Chip';
import AdderProductCard from '@src/domains/products/features/multiProductBooking/AdderProductCard';
import {
  ProductList,
  ProductListArea,
  ProductListFooter,
  ProductListFooterInfo,
  ProductListHeader,
  ProductListScrollableContent,
} from './styles';

interface AdderProductListProps {
  title: string;
  products: Product[];
  selectedProductId: string | undefined;
  countFilled: number;
  isAllFilled: boolean;
  isProductFilled: (productId: string) => boolean;
  getSelectedDate: (productId: string) => string | undefined;
  getSelectedTime: (productId: string) => string | undefined;
  getSelectedTariffs: (productId: string) => TariffsPerType[] | undefined;
  shouldBeDisabled: (productId: string) => boolean;
  onSelect: (productId: string) => void;
  footer?: React.ReactNode;
  appId?: string;
}

const AdderProductList = (props: Readonly<AdderProductListProps>) => {
  const {
    title,
    products,
    selectedProductId,
    countFilled,
    isAllFilled,
    isProductFilled,
    getSelectedDate,
    getSelectedTime,
    getSelectedTariffs,
    shouldBeDisabled,
    onSelect,
    footer,
    appId,
  } = props;

  return (
    <ProductListArea>
      <ProductListScrollableContent>
        <ProductListHeader>
          <p>{title}</p>

          <Chip
            color={isAllFilled ? 'success' : 'primary'}
            label={
              <>
                {countFilled}/{products.length}
                {isAllFilled ? <IconCheck size={16} /> : null}
              </>
            }
          />
        </ProductListHeader>

        <ProductList>
          {products.map((product) => (
            <AdderProductCard
              key={product.id}
              product={product}
              isProductFilled={isProductFilled(product.id)}
              isSelected={product.id === selectedProductId}
              selectedDate={getSelectedDate(product.id)}
              selectedHour={getSelectedTime(product.id)}
              selectedTariffs={getSelectedTariffs(product.id)}
              onClick={onSelect}
              disabled={shouldBeDisabled(product.id)}
              appId={appId}
            />
          ))}
        </ProductList>
      </ProductListScrollableContent>

      {footer ? <ProductListFooter>{footer}</ProductListFooter> : null}
    </ProductListArea>
  );
};

export { ProductListFooterInfo };
export default memo(AdderProductList);
